import Push from 'push.js'
import debug from 'debug'

const dbg = debug('push:notifications')

function NotifyPermissions () {
  if (!Push.Permission.has()) {
    dbg('Notification is disabled. Prompt for permissions grant')
    Push.Permission.request(() => {
      dbg('Notification permission is granted')
    }, () => {
      dbg('Notification permission is denied')
    })
  } else {
    dbg('Notification is enabled')
  }
}

function NotifyCallIn (tag, title, body, avatar, timeout) {
  if (!Push.Permission.has()) {
    dbg('Permission to display notification is not granted')
    return
  }

  if (document.hasFocus()) {
    dbg('Skip notification for active tab focus')
    return
  }

  Push.create(title, {
    body: body,
    tag: tag,
    icon: avatar,
    timeout: timeout,
    onClick: function () {
      window.focus()
      this.close()
    }
  })
}

function NotifyMessageIn (tag, title, body, avatar, actionUrl, timeout) {
  if (!Push.Permission.has()) {
    dbg('Permission to display notification is not granted')
    return
  }

  if (document.hasFocus()) {
    dbg('Skip notification for active tab focus')
    return
  }

  Push.create(title, {
    body: body,
    tag: tag,
    icon: avatar,
    timeout: timeout,
    onClick: function () {
      window.open(actionUrl, '_blank')
      window.focus()
      this.close()
    }
  })
}

function NotifyClear (tag) {
  Push.close(tag)
}

export { NotifyPermissions, NotifyCallIn, NotifyClear, NotifyMessageIn }
